import { useDocumentMetadata } from '@hooks/useDocumentMetadata'
import GameGallery from './GameGallery'
import styles from './HomeScreen.module.css'

/**
 * HomeScreen - Landing hub for game selection
 *
 * Main entry point for /:lang routes.
 * Displays available games in a responsive gallery.
 *
 * Architecture:
 * - Minimal orchestrator (delegates to GameGallery)
 * - Handles document metadata
 * - No layout logic (handled by ScreenWrapper in App.jsx)
 *
 * Route: /:lang
 */
export default function HomeScreen () {
  useDocumentMetadata()

  return (
    <div className={styles.homeScreen}>
      <GameGallery />
    </div>
  )
}
